import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g(_vm._b({staticClass:"pa-2 wizard-step-button",attrs:{"height":"auto","depressed":"","block":"","large":"","text":"","ripple":false,"color":'var(--colorPrimary)'}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"f20 font-weight-semi-bold",staticStyle:{"text-transform":"none"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }